module.exports = __webpack_public_path__ + "img/step4.8c4c2af1.png";